// Return true if number string is already '0' and you try to add more leading zeros, else return false

export function LeadingZeros(key: string, previousValue: string): boolean {
  if (
    previousValue === null ||
    previousValue === undefined ||
    previousValue === ''
  ) {
    return false;
  }

  if (previousValue === '0' && key !== '.' && key !== 'Backspace') {
    return true;
  }
  return false;
}
